import React, { useEffect } from 'react';
import { Button } from '@mui/material';
import toast from 'react-hot-toast';
import {
  useFindByBookingIdMutation,
  useGetAllBookingDetailBySearchCriteriaMutation,
  useSaveBookingDetailMutation,
  useUpdateBookingDetailMutation,
} from '../store/api/bookingsApi';
import {
  useFindAccountDetailByServiceProviderMutation,
  useGetAllAccountDetailMutation,
} from '../store/api/accountsApi';

const TestingApi = () => {
  const [findByBookingId, response] = useFindByBookingIdMutation();
  const [getAllBookingDetailBySearchCriteria, responseObject] = useGetAllBookingDetailBySearchCriteriaMutation();
  const [findAccountDetailByServiceProvider, responsel] = useFindAccountDetailByServiceProviderMutation();
  const [getAllAccountDetail, responseB] = useGetAllAccountDetailMutation();
  const token = JSON.parse(localStorage.getItem('login') || '{}') || null;
  useEffect(() => {
    if (response.isSuccess) {
      toast.success('Get Booking Overview Detail By Search Criteria');
    }
  }, [response.isSuccess]);
  useEffect(() => {
    if (responseObject.isSuccess) {
      toast.success('Find By Booking Id');
    }
  }, [responseObject.isSuccess]);
 
  return (
    <div style={{ padding: '25px' }}>
      <Button
        onClick={() => {
          getAllBookingDetailBySearchCriteria({
            token: token.token,
            reqData: { columnName: '', currentStage: '', flag: '', offset: 100, orderBy: '', page: 0 },
          });
        }}
        variant="outlined"
        style={{ marginBottom: '10px' }}
      >
        Test Api - getAllBookingDetailBySearchCriteria
      </Button>
      <Button
        onClick={() => {
          findByBookingId({ token: token.token, id: 4 });
        }}
        variant="outlined"
        style={{ marginBottom: '10px' }}
      >
        Test Api - findByBookingId
      </Button>
      <Button
        onClick={() => {
          getAllAccountDetail({
            page: 0,
            offset: 10,
            token: token.token,
          });
        }}
        variant="outlined"
        style={{ marginBottom: '10px' }}
      >
        Test Api - getAllAccountDetail
      </Button>
      <Button
        onClick={() => {
          findAccountDetailByServiceProvider({
            id: 43,
            token: token.token,
          });
        }}
        variant="outlined"
        style={{ marginBottom: '10px' }}
      >
        Test Api - findAccountDetailByServiceProvider
      </Button>
     {/**  <Button
        onClick={() => {
          getAllServiceProviderFeedback({
            token: token.token,
            payload: {
              page: 0,
              offset: 10,
              serviceProviderId: 43,
            },
          });
        }}
        variant="outlined"
        style={{ marginBottom: '10px' }}
      >
        Test Api - getAllServiceProviderFeedback
      </Button> */}
    </div>
  );
};

export default TestingApi;
